
import { Box, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
import CustomButton from 'components/shared/CustomButton/CustomButton';
import CustomCard from 'components/shared/CustomCard/CustomCard';
import CustomModal from 'components/shared/CustomModal/CustomModal';
import { useState } from 'react';
import zeplinColor from 'theme/Color';

type TaskTypeSelectionModalProps = {
  isModalOpen: boolean;
  onClose: () => void;
  onSelect: (taskType: string) => void;
};

export const TaskTypeSelectionModal = ({
  isModalOpen,
  onClose,
  onSelect,
}: TaskTypeSelectionModalProps) => {
  const [taskTypeSelected, setTaskTypeSelected] = useState('');

  const handleTaskTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTaskTypeSelected(event.target.value);
  };

  const taskTypes = ['A&A Management Task', 'Brick Media Task', 'Payment Task'];

  const handleContinue = () => {
    if (taskTypeSelected) {
      onSelect(taskTypeSelected);
      setTaskTypeSelected('');
      onClose();
    }
  };

  const handleClose = () => {
    setTaskTypeSelected('');
    onClose();
  };

  return (
    <CustomModal handleClose={handleClose} open={isModalOpen}>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <CustomCard
          styles={{
            borderRadius: '14px',
            padding: '24px',
            backgroundColor: zeplinColor.Neutral1,
            width: { xs: '280px', xl: '312px' },
            boxShadow: 'rgba(0, 0, 0, 0.15)',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: { xs: '18px', xl: '24px' },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Typography variant='responsiveHeading3' color={zeplinColor.BasicBlack}>
                Select Task Type
              </Typography>
              <img
                src={'/assets/cross.svg'}
                alt='close'
                onClick={handleClose}
                style={{ cursor: 'pointer' }}
              />
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: { xs: '10px', xl: '16px' },
              }}
            >
              <RadioGroup
                aria-labelledby='task-type-radio-group'
                name='task-type-radio-group'
                value={taskTypeSelected}
                onChange={handleTaskTypeChange}
                sx={{
                  color: zeplinColor.BasicBlack,
                  '&.Mui-checked': {
                    color: zeplinColor.BasicBlack,
                  },
                  padding: '0px',
                }}
              >
                {taskTypes.map((name) => (
                  <FormControlLabel
                    key={name}
                    value={name}
                    control={
                      <Radio
                        sx={{
                          color: zeplinColor.BasicBlack,
                          '&.Mui-checked': {
                            color: zeplinColor.BasicBlack,
                          },
                        }}
                      />
                    }
                    label={name}
                    sx={{
                      color: zeplinColor.BasicBlack,
                      '& .MuiButtonBase-root': {
                        color: zeplinColor.BasicBlack,
                      },
                      padding: '0px',
                    }}
                  />
                ))}
              </RadioGroup>
            </Box>
            <CustomButton
              disabled={!taskTypeSelected}
              onClick={handleContinue}
              variant='contained'
              color={'primary'}
              style={{
                width: '100%',
                borderRadius: '14px',
                height: 48,
                padding: '14px 16px',
                '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
              }}
              textStyle={{ color: zeplinColor.Neutral1 }}
              text={'Continue'}
            />
          </Box>
        </CustomCard>
      </Box>
    </CustomModal>
  );
};
